import { useMutation } from "@tanstack/react-query";

import { logoutRequest } from "../requests/logout-request";

export const useLogoutMutation = () => {
  return useMutation({
    mutationFn: logoutRequest,
  });
};
